import {React,useState,useEffect} from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";
import { activityDataDashboard } from "common/data";
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ActivityComp = () => {
   const [agent, setAgent] = useState('')
      const [agentCode, setAgentcode] = useState('')
      const [renewals, setRenewals] = useState([])
        const [credentials, setCredentials] = useState(null)
        const [isAuth, setIsauth] = useState(false)
        const company = 'Definite'
      
        useEffect(()=>{
        const getCredentials =async()=>{
          const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
          const data = await res.json();
          const {Username, Password} = data;
          const cred = btoa(`${Username}:${Password}`)
          setCredentials(btoa(`${Username}:${Password}`))
          setIsauth(true)
      
      
        }
        getCredentials()
      
        },[])


          useEffect(() => {
              
          const user = localStorage.getItem('definiteagent'); // Retrieve email
          if (user) {
              
              setAgent(user)
          } else {
      
          }
          }, []);
      useEffect(()=>{
              const getAgentcode =async()=>{
                  const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                      method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                  });
                  const data = await res.json();
                  setAgentcode(data.OID)   
      
              }
              if(agent && isAuth){
                  getAgentcode()
              }
          },[agent,isAuth])
      
          useEffect(()=>{
             
      
            const getUpcomingRenewals =async()=>{
              const res = await fetch(`https://digitalapi.definiteassurance.com/api/getUpcomingrenewals2?agent=${agentCode}`,{
                  method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
              });
              const data = await res.json();
              setRenewals(data)
            }
      
              if(agentCode && isAuth){
                
                 getUpcomingRenewals()
              }
      
          },[agentCode,isAuth])

          function formateDateISO(input){
            if(typeof input === 'string'){
                return input.split('T')[0]
            }
            else if (input instanceof Date){
                return input.toISOString().split('T')[0]
            }
    
            throw new Error('Invalid input: Expected ISO String or Date Object')
        }
  return (
    <div>
      <Card>
        <CardBody>
          <CardTitle className="mb-5">Upcoming renewals</CardTitle>
           <div className="table-responsive" style={{padding:'10px',height:'170px',overflowY:'scroll'}}>
                  
                  
              <Table striped bordered hover id="policy-table">
              <thead>
                  <tr>
                  <th scope="col">#</th>
                  <th scope="col">Insured</th>
                  <th scope="col">Registration</th>     
                  <th scope="col">Expiry Date</th>
               


                  </tr>
              </thead>
              <tbody>
                  {renewals.map((val, index) => {
                  // Calculate the correct index based on current page
                
                          return (
                              <tr key={val.OID}>
                              <td>{index + 1}</td>
                              <td>{val.Dealer_name}</td>
                              <td>{val.Narration}</td>
                              <td>{formateDateISO(val.ExpiryDate)}</td>
                             
                              </tr>
                          );

                  })}
              </tbody>
              </Table>
                  </div>
          
          
        </CardBody>
      </Card>
    </div>
  );
};

export default ActivityComp;